import { render, staticRenderFns } from "./vipInfo.vue?vue&type=template&id=6f78fce8&scoped=true"
import script from "./vipInfo.vue?vue&type=script&lang=js"
export * from "./vipInfo.vue?vue&type=script&lang=js"
import style0 from "./vipInfo.vue?vue&type=style&index=0&id=6f78fce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78fce8",
  null
  
)

export default component.exports